'use strict';

angular.module('ringbaPortal')
  .directive('compareFieldSelector', function() {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        const compareElement = elem
          .closest('form')
          .find(attrs.compareFieldSelector);

        elem.on('keyup', function () {
          scope.$apply(function () {
            const v = (elem.val() === compareElement.val());

            ctrl.$setValidity('comparefield', v);
          });
        });

        compareElement.on('keyup', function () {
          scope.$apply(function () {
            const v = (elem.val() === compareElement.val());

            ctrl.$setValidity('comparefield', v);
          });
        });
      }
    };
  })
;
